import clsx from "clsx"

import { headingElements } from "./config"
import type { TitleProps } from "./types"

type DisplayProps = Pick<TitleProps, "className" | "children" | "level" | "testId">

/**
 * This component is only part of the Marketing Design System typography.
 * Do not use in Expo apps.
 */
export const Display = ({ children, className, level, testId }: DisplayProps) => {
  const H = headingElements[level ?? 1]

  return (
    <H
      data-testid={testId ?? `title-display`}
      className={clsx(
        "font-display font-bold",
        "text-[3.6875rem] lg:text-[4.5rem]",
        "leading-[1.1] lg:leading-[1.2]",
        "tracking-[0.01em] lg:tracking-normal",
        className,
      )}>
      {children}
    </H>
  )
}
